import { memo } from 'react';

import { PublicTopBarAccountInfo } from '~/components/Layouts/PublicBoardLayout/PublicTopBarAccountInfo';
import { PublicTopBar } from '~/components/PublicTopBar';
import { PublicWorkspaceInfo } from '~/components/PublicWorkspaceInfo';
import { useAccountContext } from '~/providers/AccountProvider';

export const PublicCanvasHeader = memo(() => {
  const { data: account } = useAccountContext();

  return (
    <div data-testid="PUBLIC_CANVAS_HEADER" className="shrink-0">
      <PublicTopBar
        workspaceInfo={<PublicWorkspaceInfo />}
        accountInfo={account ? <PublicTopBarAccountInfo account={account} /> : null}
      />
    </div>
  );
});

PublicCanvasHeader.displayName = 'PublicCanvasHeader';
